import { type AppType } from "next/app";
import { useEffect } from "react";
import { SpeedInsights } from "@vercel/speed-insights/next";
import { startAnalytics } from "~/lib/analytics/client";

import "~/styles/globals.css";
import "~/styles/modal-theme.css";
import "~/styles/whop-login.css";

// Everything imported here ships with every page, so this file holds global
// CSS, the portal root, and the Speed Insights beacon only. Pages that call
// API hooks wrap themselves with withApiClient (src/components/app), which
// keeps the tRPC client, react-query, and superjson out of marketing pages.
// The MUI theme mounts around the courses admin editor, the only place that
// renders MUI components, and the toaster lives in the member shell and on
// contact-us, the surfaces that call useToast. Clerk stays out of this file
// for the same reason: ClerkProvider mounts per surface through
// ~/components/auth/ClerkProviderBoundary (statically on /sso-callback and
// /account/sign-in-methods, dynamically inside the dashboard sign-in panel
// chunk), so the @clerk/nextjs client SDK never enters the shared _app chunk.
// Analytics and error reporting start here, after hydration, and stay off
// without their keys. The loader lives in this shared chunk on purpose: as a
// client instrumentation file Next injected it into every page entry, and on
// pages without the member shell the bundler merged its references to the
// analytics libraries into the chart engine's chunk, which the bundle budget
// then counted at 264 KB and 275 KB against 35 KB (October 7, 2026).
const MyApp: AppType = ({ Component, pageProps }) => {
  useEffect(() => {
    startAnalytics();
  }, []);
  return (
    <>
      <Component {...pageProps} />
      <div id="MODAL_PORTAL"></div>
      <SpeedInsights />
    </>
  );
};

export default MyApp;
